import React from "react";
import { Link } from "react-router-dom";
import { useData } from "../DataContext";
import { usePageMeta } from "../hooks/usePageMeta";

const Group = ({ title, children }) => (
  <div>
    <h2 className="text-lg font-black text-[#0a2a5e] mb-4 pb-2 border-b border-slate-200">{title}</h2>
    <ul className="space-y-2">{children}</ul>
  </div>
);

const Item = ({ to, label }) => (
  <li>
    <Link to={to} className="text-slate-600 hover:text-sky-600 transition-colors text-sm">{label}</Link>
  </li>
);

export default function Sitemap() {
  usePageMeta("Sitemap", "Browse every page and product on the Baishalii Tanks & Pipes website from one place.");
  const { PRODUCT_CATEGORIES } = useData();
  return (
    <div className="pt-[88px] md:pt-[112px]" data-testid="sitemap-page">
      <section className="relative py-20 bg-gradient-to-r from-[#061a3d] via-[#0a2a5e] to-sky-700 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-4xl sm:text-5xl font-black">Sitemap</h1>
          <p className="text-sky-200 mt-4">Everything on baishalii.in, in one place.</p>
        </div>
      </section>
      <section className="py-14 md:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
          <Group title="Main Pages">
            <Item to="/" label="Home" />
            <Item to="/about" label="About Us" />
            <Item to="/products" label="Products" />
            <Item to="/resources" label="Resources" />
            <Item to="/blog" label="Blog" />
            <Item to="/contact" label="Contact" />
          </Group>
          <Group title="Product Categories">
            {PRODUCT_CATEGORIES.map((c) => (
              <Item key={c.id} to={`/products#${c.id}`} label={c.name} />
            ))}
          </Group>
          <Group title="Legal">
            <Item to="/privacy-policy" label="Privacy Policy" />
            <Item to="/terms-of-use" label="Terms of Use" />
            <Item to="/sitemap" label="Sitemap" />
          </Group>
          {PRODUCT_CATEGORIES.map((c) => (
            <Group key={c.id} title={c.name}>
              {c.products.map((p) => (
                <Item key={p.slug} to={`/products/${p.slug}`} label={p.series ? `${p.name} (${p.series})` : p.name} />
              ))}
            </Group>
          ))}
        </div>
      </section>
    </div>
  );
}
